import { Component, Input, OnInit } from '@angular/core';
import { faCaretLeft, faAngleRight, faPlaneDeparture, faAngleDown, faPlaneArrival } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';

@Component({
  selector: 'app-flight-detail',
  templateUrl: './flight-detail.component.html',
  styleUrls: ['./flight-detail.component.scss']
})
export class FlightDetailComponent implements OnInit {
  icons = {
    caretLeft: faCaretLeft,
    caretRight: faAngleRight,
    departure: faPlaneDeparture,
    arrival: faPlaneArrival,
    caretDown: faAngleDown,
  }
  @Input() accordionId: string = "default";
  @Input() data: any;
  @Input() stopCount: number;

  constructor() { }

  ngOnInit() {
  }

  getTime(value: any) {
    const formattedTime = moment(value, 'HH:mm').format('H [hours] m [minutes]');
    return formattedTime;
  }

}
